import { render, staticRenderFns } from "./Product.vue?vue&type=template&id=538a4c8c&scoped=true&"
import script from "./Product.vue?vue&type=script&lang=js&"
export * from "./Product.vue?vue&type=script&lang=js&"
import style0 from "./Product.vue?vue&type=style&index=0&id=538a4c8c&lang=stylus&scoped=true&"
import style1 from "./Product.vue?vue&type=style&index=1&lang=stylus&"
import style2 from "./Product.vue?vue&type=style&index=2&id=538a4c8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538a4c8c",
  null
  
)

export default component.exports